import preset from '../preset';

export type base_margin =
    | 'none'
    | 'default'
    | 'auto'
    | 'xs'
    | '_xs'
    | 'sm'
    | '_sm'
    | 'xmd'
    | '_xmd'
    | 'md'
    | '_md'
    | 'xlg'
    | '_xlg'
    | 'lg'
    | '_lg'
    | 'xl'
    | '_xl'
    | 'sl'
    | '_sl'
    | '_3xl';

export type margin_x = base_margin;
export type margin_y = base_margin;
export type margin_top = base_margin;
export type margin_bottom = base_margin;
export type margin_left = base_margin;
export type margin_right = base_margin;

export type margin =
    | base_margin
    | 'default-x'
    | 'default-y'
    | 'default-t'
    | 'default-b'
    | 'default-l'
    | 'default-r'
    | 'auto-x'
    | 'auto-y'
    | 'auto-t'
    | 'auto-b'
    | 'auto-l'
    | 'auto-r'
    | 'xs-x'
    | 'xs-y'
    | 'xs-t'
    | 'xs-b'
    | 'xs-l'
    | 'xs-r'
    | '_xs-x'
    | '_xs-y'
    | '_xs-t'
    | '_xs-b'
    | '_xs-l'
    | '_xs-r'
    | 'sm-x'
    | 'sm-y'
    | 'sm-t'
    | 'sm-b'
    | 'sm-l'
    | 'sm-r'
    | '_sm-x'
    | '_sm-y'
    | '_sm-t'
    | '_sm-b'
    | '_sm-l'
    | '_sm-r'
    | 'xmd-x'
    | 'xmd-y'
    | 'xmd-t'
    | 'xmd-b'
    | 'xmd-l'
    | 'xmd-r'
    | '_xmd-x'
    | '_xmd-y'
    | '_xmd-t'
    | '_xmd-b'
    | '_xmd-l'
    | '_xmd-r'
    | 'md-x'
    | 'md-y'
    | 'md-t'
    | 'md-b'
    | 'md-l'
    | 'md-r'
    | '_md-x'
    | '_md-y'
    | '_md-t'
    | '_md-b'
    | '_md-l'
    | '_md-r'
    | 'xlg-x'
    | 'xlg-y'
    | 'xlg-t'
    | 'xlg-b'
    | 'xlg-l'
    | 'xlg-r'
    | '_xlg-x'
    | '_xlg-y'
    | '_xlg-t'
    | '_xlg-b'
    | '_xlg-l'
    | '_xlg-r'
    | 'lg-x'
    | 'lg-y'
    | 'lg-t'
    | 'lg-b'
    | 'lg-l'
    | 'lg-r'
    | '_lg-x'
    | '_lg-y'
    | '_lg-t'
    | '_lg-b'
    | '_lg-l'
    | '_lg-r'
    | 'xl-x'
    | 'xl-y'
    | 'xl-t'
    | 'xl-b'
    | 'xl-l'
    | 'xl-r'
    | '_xl-x'
    | '_xl-y'
    | '_xl-t'
    | '_xl-b'
    | '_xl-l'
    | '_xl-r'
    | 'sl-x'
    | 'sl-y'
    | 'sl-t'
    | 'sl-b'
    | 'sl-l'
    | 'sl-r'
    | '_sl-x'
    | '_sl-y'
    | '_sl-t'
    | '_sl-b'
    | '_sl-l'
    | '_sl-r';

export const marginClass = preset.xclasses<margin>('margin');
export const marginXClass = preset.xclasses<margin_x>('marginX');
export const marginYClass = preset.xclasses<margin_y>('marginY');
export const marginTopClass = preset.xclasses<margin_top>('marginTop');
export const marginBottomClass = preset.xclasses<margin_bottom>('marginBottom');
export const marginLeftClass = preset.xclasses<margin_left>('marginLeft');
export const marginRightClass = preset.xclasses<margin_right>('marginRight');

export default marginClass;
